module.exports = __webpack_public_path__ + "img/3.e86f1666.jpg";